import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import React from 'react';
import { ConfirmDelete } from './Content/ConfirmDelete';
import { SelectAlarms } from './Content/SelectAlarms';

export default function BulkDeleteAlarms() {
    const initialData = {
        ids: []
    };

    const steps = [
        { Component: SelectAlarms, title: i18next.t('alarms.bulk_delete'), description: i18next.t('alarms.select_alarms') },
        { Component: ConfirmDelete, title: i18next.t('alarms.bulk_delete'), description: i18next.t('alarms.bulk_delete_description') }
    ];

    const handleSubmit = async data => {
        try {
            const response = await apiRequest('/alarms/bulk_destroy', 'DELETE', { ids: data.ids });

            WiseMetering.alarms.fetch();

            return response;
        } catch (err) {
            throw new Error(err); // Throwing it so Wizard can catch
        }
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
